import { jsxs as n, jsx as e } from "react/jsx-runtime";
import { getMainIconProps as o } from "./index.es2444.js";
function a(d) {
  const { outline: i, fill: p, size: t, innerElementFill: l } = o(d);
  return /* @__PURE__ */ n(
    "svg",
    {
      width: t,
      height: t,
      viewBox: "0 0 18 18",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ n("g", { clipPath: "url(#clip0_260_3528)", children: [
          /* @__PURE__ */ e(
            "path",
            {
              shapeRendering: "optimizeQuality",
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M6.5 17.625C9.877 17.625 12.625 14.877 12.625 11.5C12.625 8.123 9.877 5.375 6.5 5.375C3.123 5.375 0.375 8.123 0.375 11.5C0.375 14.877 3.123 17.625 6.5 17.625Z",
              fill: p
            }
          ),
          /* @__PURE__ */ e(
            "path",
            {
              shapeRendering: "optimizeQuality",
              d: "M5 0.75H17C17.1381 0.75 17.25 0.861929 17.25 1V15C17.25 15.1381 17.1381 15.25 17 15.25H11.3396C11.1309 15.5187 10.9004 15.7696 10.6508 16H17C17.5523 16 18 15.5523 18 15V1C18 0.447715 17.5523 0 17 0H5C4.44772 0 4 0.447715 4 1V5.90875C4.24213 5.80005 4.49254 5.70663 4.75 5.62972V1C4.75 0.861929 4.86193 0.75 5 0.75Z",
              fill: i
            }
          ),
          /* @__PURE__ */ e(
            "path",
            {
              shapeRendering: "optimizeQuality",
              d: "M16 2.9165H6V2.0835H16V2.9165Z",
              fill: i
            }
          ),
          /* @__PURE__ */ e(
            "path",
            {
              shapeRendering: "optimizeQuality",
              d: "M10 4.9165H16V4.0835H10V4.9165Z",
              fill: i
            }
          ),
          /* @__PURE__ */ e(
            "path",
            {
              shapeRendering: "optimizeQuality",
              d: "M16 6.9165H13V6.0835H16V6.9165Z",
              fill: i
            }
          ),
          /* @__PURE__ */ e(
            "path",
            {
              shapeRendering: "optimizeQuality",
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M0.75 11.5C0.75 14.6699 3.33011 17.25 6.5 17.25C9.66989 17.25 12.25 14.6699 12.25 11.5C12.25 8.33011 9.66989 5.75 6.5 5.75C3.33011 5.75 0.75 8.33011 0.75 11.5ZM6.5 18C2.91589 18 0 15.0841 0 11.5C0 7.91589 2.91589 5 6.5 5C10.0841 5 13 7.91589 13 11.5C13 15.0841 10.0841 18 6.5 18Z",
              fill: i
            }
          ),
          /* @__PURE__ */ e(
            "path",
            {
              shapeRendering: "optimizeQuality",
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M9 11.875H3V11.125H9V11.875Z",
              fill: l
            }
          ),
          /* @__PURE__ */ e(
            "path",
            {
              shapeRendering: "optimizeQuality",
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M8.47319 11.4997L6.73783 13.2351L7.26816 13.7654L9.53401 11.4995L7.26808 9.23499L6.73791 9.76548L8.47319 11.4997Z",
              fill: l
            }
          )
        ] }),
        /* @__PURE__ */ e("defs", { children: /* @__PURE__ */ e("clipPath", { id: "clip0_260_3528", children: /* @__PURE__ */ e(
          "rect",
          {
            shapeRendering: "optimizeQuality",
            width: "18",
            height: "18",
            fill: l
          }
        ) }) })
      ]
    }
  );
}
a.__tags = [];
export {
  a as GetReportIcon
};
//# sourceMappingURL=index.es296.js.map
